import api from './request.manage'

export const baseurl='http://gyxf.cuc.edu.cn';

export const ConfirmRoomSave=(param:any)=>{
    return api.post(baseurl+'/api/student/ConfirmRoomSave?uid='+param);
};

export const getStudentByID=(idnumber:any)=>{
    return api.get(baseurl+'/api/student/getStudentByID?idnumber='+idnumber);
};

export const Managelogin=(param:any)=>{
    return api.post(baseurl+'/api/LoginManager',param);
}